export default "__VITE_ASSET__Mr_hXtXh__"